export default __webpack_public_path__ + "static/media/mon_256.d56fe911.png";